<template>
  <form id="batchDeployImsDetailForm">
    <div class="row h-row-inputBox">
      <div class="col-sm-6 h-col-inputBox">
        <div>
          <div class="h-inputLit"><span class="h-red-code">* </span>{{$t('NSMF.envChoice')}} :</div>
          <ejs-dropdownlist
            ref="envSelect"
            id="environmentParent"
            :fields="fieldsEnv"
            :dataSource="envItems"
            popupHeight="200"
            v-model="environmentParent"
            :change="onMethodChangeParent"
            name="environmentCheck"
          ></ejs-dropdownlist>
        </div>
      </div>
      <div class="col-sm-6 h-col-inputBox">
        <div>
          <div class="h-inputLit">命名空间:</div>
          <ejs-combobox class="e-input" name="namespaceCheck" v-model="namespace" :dataSource='namespaceList' :fields='fieldsodNamespace' @change="changeForStatus"></ejs-combobox>
        </div>
      </div>
    </div>
  </form>
</template>
<script>
import { EventBus } from "../../../plugins/eventBus";
import { FormValidator } from "@syncfusion/ej2-vue-inputs";

export default {
  name: "BatchDeployImsDetail",
  components: {},
  data() {
    return {
      environmentParent: 0,
      envItems: [],
      envIpParent: "",
      namespace:"default",
      fieldsEnv: { text: "k8sName", value: "id" },
      locale: localStorage.getItem("locale"),

      formObj: "",
      validationOption: {
        customPlacement(inputElement, errorElement) {
          errorElement.style.float = "left";
          inputElement.parentElement.parentElement.appendChild(errorElement);
        },
        rules: {
          environmentCheck: {
            required: [true, `${this.$t("Pm.alertRequired")}`]
          },
          namespaceCheck: {
            required: [true, `${this.$t("Pm.alertRequired")}`],
            regex: [/^[A-Za-z0-9]+$/, `${this.$t("Pm.onlyNumAndLetter")}`],
            maxLength: [30, `${this.$t("Topo.topoMaxLength")}30`]
          },
        }
      },
      fieldsodNamespace: {
        text: "text",
        value: "value"
      },
      namespaceList:[],  
    };
  },
  methods: {
    changeForStatus(msg) {
      this.namespace = msg.value;
      EventBus.$emit("imsNamespaceParam", {
        namespaceParam: this.namespace,
      });
    },
    getNameSpace() {
      this.$axios.get("/lte/ems/networkSlice/listServiceSliceSubnetAll").then(response => {
        if (
          response &&
          response.status === 200 &&
          response.data !== undefined&&
          response.data.resultVal !== undefined
        ) {
          for(let i=0;i<response.data.resultVal.length;i++){
            let namespaceEach={text:response.data.resultVal[i].namespace,value:response.data.resultVal[i].namespace};
            this.namespaceList.push(namespaceEach);
          }
        }
      });
    },
    onMethodChangeParent(e) {
      for (var i = 0; i < this.envItems.length; i++) {
        if (this.envItems[i].id == this.environmentParent) {
          this.envIpParent = this.envItems[i].k8sEnvIp;
        }
      }
      EventBus.$emit("imsEnvironmentParam", {
        environmentParent: this.environmentParent,
        envIp: this.envIpParent,
      });
      this.$parent.$refs.deployCase43[0].onMethodChange();
      this.$parent.$refs.deployCase44[0].onMethodChange();
      this.$parent.$refs.deployCase45[0].onMethodChange();
      this.$parent.$refs.deployCase46[0].onMethodChange();
      this.$parent.$refs.deployCase47[0].onMethodChange();
      this.$parent.$refs.deployCase48[0].onMethodChange();
    },
    init(checkedData) {
      this.getEnvItems();
      this.getNameSpace();
      try {
        this.bindValidate();
      } catch (e) {
        console.log(e);
      }
    },
    getEnvItems() {
      this.$axios
        .get("/lte/ems/env/getEnvironmentWithIngressIp")
        .then(response => {
          this.envItems = response.data.resultVal;
        });
    },
    getInstanceBase(callback) {
      if (!this.validate()) {
          if (callback) {
            callback(false);
          }      
      }
      callback({
        environment: this.environmentParent,
        namespace: this.namespace,
        // envIpParent: this.envIpParent
      });
    },
    bindValidate() {
      this.formObj = new FormValidator(
        "#batchDeployImsDetailForm",
        this.validationOption
      );
    },
    validate() {
      const formStatus = this.formObj.validate();
      return formStatus;
    }
  },
  mounted() {
    this.bindValidate();
  }
};
</script>
